"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModal = exports.Modal = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const Modal_1 = require("@reactionable/core/lib/ui/modal/Modal");
const Modal_2 = tslib_1.__importDefault(require("react-bootstrap/Modal"));
const Modal = (_a) => {
    var { title, children, body, footer, onHide } = _a, modalProps = tslib_1.__rest(_a, ["title", "children", "body", "footer", "onHide"]);
    const handleOnClose = () => {
        onHide && onHide();
    };
    return (jsx_runtime_1.jsxs(Modal_2.default, Object.assign({ centered: true, backdrop: "static", onHide: handleOnClose }, modalProps, { children: [jsx_runtime_1.jsx(Modal_2.default.Header, Object.assign({ closeButton: true }, { children: jsx_runtime_1.jsx(Modal_2.default.Title, { children: title }, void 0) }), void 0), children, body && jsx_runtime_1.jsx(Modal_2.default.Body, { children: body }, void 0),
            footer && jsx_runtime_1.jsx(Modal_2.default.Footer, { children: footer }, void 0)] }), void 0));
};
exports.Modal = Modal;
function useModal(props) {
    return Modal_1.useModal(Object.assign({ Component: exports.Modal }, props));
}
exports.useModal = useModal;
//# sourceMappingURL=Modal.js.map